import { InteractionAppointment } from '@/shared/interaction-appointment';
import { InteractionClient } from '@/shared/interaction-client';

export interface Interaction {
    id?: string | null;
    interactionTypeId: string | null;
    interactionOutcomeTypeId: string | null;
    letterTypeId: string | null;
    notes: string | null;
    callbackDate: string | Date | null;
    allowFutureContact: boolean | null;
    version?: number;
    createdDate?: string | Date | null;
    createdBy?: string | null;
    lastModifiedDate?: string | Date | null;
    lastModifiedBy?: string | null;
    originalAppointment: InteractionAppointment | null;
    appointment?: InteractionAppointment | null;
    clients?: Array<InteractionClient>;
}

export function createInteraction(): Interaction {
    return {
        interactionTypeId: null,
        interactionOutcomeTypeId: null,
        letterTypeId: null,
        notes: null,
        callbackDate: null,
        allowFutureContact: null,
        originalAppointment: null,
    };
}
